import type { authData } from '../entities/AuthData'
const loggedUserRedirect = (userData: authData): string => {
  const returnUrlCookie = useCookie('returnUrl')
  const returnUrl = returnUrlCookie.value
  returnUrlCookie.value = null

  if (userData.userType.toLowerCase() === 'owner') {
    if (userData.isOwnerRegister) {
      return routes().ownerNewCottage({
        ownerId: userData.userId,
      })
    } else if (returnUrl && routesValidation().isOwnerRoute(returnUrl)) {
      return returnUrl
    }

    return routes().calendarQuickRentUnit({
      ownerId: userData.userId,
    })
  } else {
    if (returnUrl) {
      return returnUrl
    }
    return routes().home()
  }
}

export default loggedUserRedirect
